import { http } from "../http";

export const getUSDNotionalRateHTTP = async data => {
  return http.post("GetUSDNotionalRate", data);
};
